'use client';
import * as RadixVisuallyHidden from '@radix-ui/react-visually-hidden';

export type VisuallyHiddenProps = RadixVisuallyHidden.VisuallyHiddenProps;

/**
 * @deprecated Use 'sr-only' className instead
 */
export const VisuallyHidden = RadixVisuallyHidden.Root;
